import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Menu24() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M3 7H21",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M3 12H21",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M3 17H21",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    })]
  });
}